import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana17Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1466_33807)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M755.395 535.899L708.625 577.272L672.648 566.479L701.43 498.123L753.596 514.313C759.352 522.947 757.194 532.301 755.395 535.899Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M643.87 634.836L708.628 577.273L624.082 553.888L604.295 625.841L643.87 634.836Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M649.262 481.934L701.429 498.123L672.647 566.479L622.28 553.887L649.262 481.934Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M595.299 467.543L649.264 481.934L622.281 555.686L570.115 539.497L595.299 467.543Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M544.931 609.654L604.293 625.844L622.281 555.689L566.517 537.7L544.931 609.654Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M487.369 591.667L544.932 609.655L566.518 537.701L510.754 521.512L487.369 591.667Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M431.607 575.477L487.372 591.667L510.757 521.512L449.596 507.121L431.607 575.477Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M374.045 562.884L431.608 575.476L449.596 507.12L392.033 492.729L374.045 562.884Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M316.479 552.088L374.042 562.882L392.03 492.727L329.071 481.934L316.479 552.088Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M258.917 546.693L316.479 552.09L329.071 481.935L266.112 472.94L258.917 546.693Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M201.354 541.298L258.917 546.695L266.112 472.942L204.951 469.345L201.354 541.298Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M131.196 537.701L201.351 541.298L204.951 469.345L124.001 501.724C113.927 523.31 124.6 534.703 131.196 537.701Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M285.901 427.969L204.953 469.342L266.114 472.94L329.074 481.934L339.867 429.768L285.901 427.969Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M413.618 435.166L339.866 429.77L329.073 481.936L390.233 492.729L399.227 494.528L413.618 435.166Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M481.97 444.161L413.614 435.167L399.223 494.529L449.591 507.121L463.982 510.718L481.97 444.161Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M541.334 456.752L481.972 444.16L463.983 510.717L510.753 521.51L519.748 523.309L541.334 456.752Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M595.301 467.545L541.335 456.752L519.749 523.309L570.117 539.499L595.301 467.545Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1466_33807" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1466_33807" transform="matrix(0.00246741 0 0 0.00327113 -5.38189 -0.95795)"/>
    </pattern>
    <image id="image0_1466_33807" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};